'use client';

import { createContext, useContext } from 'react';
import type { IAdobeData } from '../types';

export interface IAdobeDataContext extends IAdobeData {
  opQueryString: string;
}

export const AdobeDataContext = createContext<IAdobeDataContext | undefined>(
  undefined,
);

export default function useAdobeDataContext(): IAdobeDataContext {
  const context = useContext(AdobeDataContext);
  if (!context) {
    throw new Error(
      'useAdobeDataContext must be used within AdobeDataContext.Provider',
    );
  }
  return context;
}
